import useSpaceliftLoginsCookie from "hooks/useSpaceliftLoginsCookie";
import { AllowedRegion, getRegion } from "utils/region";

type UseAvailableLoginsOptions = {
  accountName: string;
};

const useAvailableLogins = ({ accountName }: UseAvailableLoginsOptions) => {
  const { cookieLoginsWithRegion } = useSpaceliftLoginsCookie();
  const currentRegion = getRegion();

  // filter out the current login and region
  const logins = cookieLoginsWithRegion.filter(
    (item: { accountName: string; region: AllowedRegion }) =>
      item.accountName !== accountName || item.region !== currentRegion
  );

  const hasMultipleRegions = new Set(cookieLoginsWithRegion.map(({ region }) => region)).size > 1;

  return {
    logins,
    hasAvailableLogins: logins.length > 0,
    hasMultipleRegions,
  };
};

export default useAvailableLogins;
